import { Stack } from "@mui/material";
import StatsCard, { IStatsCardProps } from "../statsCard";
type IStatsSectionProps = {
  isSM: boolean;
  widePad: string;
  smPad: string;
  stats: IStatsCardProps[];
};
const StatsSection = ({
  isSM,
  widePad,
  smPad,
  stats
}: IStatsSectionProps) => {
  return (
    <Stack
      direction={isSM ? "column" : "row"}
      gap={"24px"}
      justifyContent={"space-between"}
      textAlign={"center"}
      sx={{
        padding: isSM ? smPad : `0px ${widePad}`,
        marginTop: isSM ? "32px" : "144px"
      }}
    >
      {stats.map((stat, idx) => (
        <StatsCard key={idx} {...stat} />
      ))}
    </Stack>
  );
};

export default StatsSection;
